export default __webpack_public_path__ + "static/media/outline_star_white_48dp 1.2911b01e.svg";